export default __webpack_public_path__ + "static/blueGreen-7e879708beb97ae07d0b2c9c323f1603.svg";